function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagSV(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURRVMsPz8/BdPthhSu/T09BlUvxpWwhtXwzVsMhtXxKK6oePl01eGVPnLNIGif/nad4unq04AAAFCSURBVDjL7ZOxSsRAEECHfMEtbHWHsCQ/IAn2N7CVd8LBkdQ2l9pO8gdLcoVduNJOtLpeCzs/QgvhivsG5cCZTfYSFVcEK/GxMzs7+3a6hfp8T1HUdb8qitXqAnI/p5B2ZNli4XZXzyBLvcy6CUfp3JXzNqyQ+Dn8XgiZKEqSOI6iLlxPQcRYK4z7wQ7RTvgaBSoMVFvvI7DJ9kmgwgYEANDsCjipAKgPPexN47nGryD8DH4oSDGi8AjT9YG4RY+wvTzBq+cPghQoeTgKOTL3d+uHytaCB6EcgESUUmpOODTV7tWUAlFzaIoBUELkk9Ty2JS7F1NqfsGL0hi0RKqa89Asnx5JIPgFvyWhPdLSE8NUdja/IlrBWVsWNrpHXyCmdL/UHoFHbLzC5PpGe4VPjKHu/VT60++qIs/P/n/3X/rdb/P+I/ei3zGpAAAAAElFTkSuQmCC",
    alt: "SV"
  }, props));
}